import { render, staticRenderFns } from "./moreDataTransferTree.vue?vue&type=template&id=dea554ec&scoped=true"
import script from "./moreDataTransferTree.vue?vue&type=script&lang=js"
export * from "./moreDataTransferTree.vue?vue&type=script&lang=js"
import style0 from "./moreDataTransferTree.vue?vue&type=style&index=0&id=dea554ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea554ec",
  null
  
)

export default component.exports